<div class="flex items-center justify-center bg-gray-100">
  <div class="w-full bg-white shadow-l p-4 md:p-8 space-y-6 rounded-lg">
    <div class="flex items-center gap-3 justify-between">
      <button class="text-gray-500 text-sm cursor-pointer flex items-center py-2 hover:underline" (click)="goBack()">
        <img ngSrc="/icons/back.svg" alt="" height="20" width="20">
        <div class="pr-2">
          Torna alla lista
        </div>
      </button>
      <button (click)="fetchRequest()" class="self-start button">
        <span class="hidden md:inline">Aggiorna Richiesta</span>
        <svg class="md:hidden" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/>
        </svg>
      </button>
    </div>

    <div class="flex flex-col flex-1">

      <div class="flex gap-3 items-center">
        <h3 class="text-gray-700 font-semibold">#{{ item.code }}</h3>
        <div class="rounded-md px-2 py-[1px] text-white"
             [ngStyle]="{'background-color': getStateColor(item.state.state)}">{{ item.state.label }}
        </div>
      </div>
      <h1 class="text-xl mt-5 mb-5">{{ item.label }}</h1>
      <div class="flex flex-wrap gap-x-3 text-gray-700 text-sm">
        <div>
          Creato il {{ item.creation_date  | date: 'dd/MM/yyyy HH:mm:ss' }}
        </div>
        <div>
          Modificato il {{ item.modification_date  | date: 'dd/MM/yyyy HH:mm:ss' }}
        </div>
      </div>
    </div>


    <div class="flex">
      <nav class="flex space-x-8" aria-label="Tabs">
        <button (click)="selectTab('documents')"
                [ngClass]="{'border-transparent text-gray-500 hover: text-gray-700 hover:border-gray-300': activeTab() !== 'documents'}"
                class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-300 focus:outline-none">
          Documenti
        </button>
        <button (click)="selectTab('messages')"
                [ngClass]="{'border-transparent text-gray-500 hover: text-gray-700 hover:border-gray-300': activeTab() !== 'messages'}"
                class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-300 focus:outline-none">
          Messaggi
        </button>
      </nav>
    </div>
    <div class="mt-6">
      @if (activeTab() === "documents") {
        <div class="p-4 rounded-lg">
          @for (document of item.documents; track document.document_id) {
            @if (document.mainDocument) {
              <div (click)="downloadDocument(document.document_id, document.mimetype)"
                class="px-6 py-4 text-blue-800 transition-colors bg-gray-100 hover:bg-gray-200 odd:bg-white even:bg-gray-100">{{ document.filename }}
              </div>
            } @else {
              <div (click)="downloadDocument(document.document_id, document.mimetype)"
                class="px-6 py-4 transition-colors bg-gray-100 hover:bg-gray-100 odd:bg-white even:bg-gray-100">{{ document.filename }}
              </div>
            }
          }
        </div>
      } @else if (activeTab() === "messages") {
        <div class="flex flex-col gap-5">
          @for (message of item.messages; track message.id; let i = $index) {
            <div class="flex flex-col gap-3 rounded-lg rounded-tl-none bg-gray-100 border-gray-300 border p-4 relative">
              <svg class="absolute -top-[1px] -left-[12px] size-3" viewBox="0 0 2 2">
                <polyline points="2,2 0,0 2,0" fill="#f6f3f4" stroke="#d1d5dc" stroke-width="1"
                          vector-effect="non-scaling-stroke"/>
              </svg>
              <div class="flex text-sm justify-between items-center  text-gray-600">
                <div class="font-bold"> {{ message.from }}</div>
                <div>{{ message.date | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
              </div>
              <div [innerHTML]="message.message"></div>
              @if (!message.answered && message.toUser) {
                <form [formGroup]="getFormForMessage(message.id)" (ngSubmit)="sendIntegration(message.id)"
                      class="w-full mt-5 mb-2 form">
                  <div><input id="requestId" formControlName="requestId" readonly hidden></div>
                  <div><input id="messageId" formControlName="messageId" readonly hidden></div>
                  <div><input id="messageId" formControlName="activityId" readonly hidden></div>
                  <div><input id="mail" formControlName="mail" readonly hidden></div>
                  <div class="relative">
                    <label for="message">Messaggio</label>
                    <textarea id="message" type="text" formControlName="message" rows="10"></textarea>
                  </div>

                  <div class="relative">
                    <label for="attachments">Allegati</label>
                    <input type="file" id="attachments" multiple (change)="onFileSelected($event)"
                           formControlName="attachments" #fileInput/>
                  </div>
                  <div class="flex justify-end mt-6">
                    <button [disabled]="getFormForMessage(message.id).invalid || submitted()" class="button"
                            type="submit">Rispondi
                    </button>
                  </div>
                  <div class="relative">
                    {{ result }}
                  </div>
                </form>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
